import classNames from "classnames";
import { ErrorBoundary } from "react-error-boundary";
import AscButton from "../AscButton/AscButton";
import AscHeading from "../AscTypography/AscHeading/AscHeading";
import AscParagraph from "../AscTypography/AscParagraph/AscParagraph";
import styles from "./AscErrorBoundary.module.scss";

export interface AscErrorBoundaryProps {
  className?: string;
  children: React.ReactNode;
  errorIllustration?: React.ReactNode;
  title?: string;
  description?: string;
  reloadButtonLabel?: string;
  onReload?: () => void;
}

export default function AscErrorBoundary({
  className,
  children,
  errorIllustration,
  title = "Something went wrong",
  description = "Please try reloading or try again later.",
  reloadButtonLabel = "Reload",
  onReload,
}: AscErrorBoundaryProps) {
  function handleReload() {
    if (onReload) {
      onReload();
      return;
    }
    typeof window !== "undefined" && window.location.reload();
  }
  return (
    <ErrorBoundary
      fallbackRender={() => {
        return (
          <div
            data-testid="asc-error-boundary-fallback"
            className={classNames(styles.ground, className)}
          >
            {errorIllustration}
            {title ? (
              <AscHeading level={3} className={styles.title}>
                {title}
              </AscHeading>
            ) : null}
            {description ? (
              <AscParagraph className={styles.description}>
                {description}
              </AscParagraph>
            ) : null}
            <AscButton onClick={handleReload}>{reloadButtonLabel}</AscButton>
          </div>
        );
      }}
    >
      {children}
    </ErrorBoundary>
  );
}
